import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { LatestForumPostsBlockProps, LatestForumPostsInteractions } from './partials/LatestForumPostsInteractions';
import { LatestForumPostsDefaultView } from './views/LatestForumPostsDefaultView';

function LatestForumPosts({ views, activeView = 'default' }: LatestForumPostsBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      // EditMode
      return <LatestForumPostsInteractions views={views} activeView={activeView} />;
    default:
      // LiveMode:
      return <LatestForumPostsDefaultView {...views.default} />;
  }
}

export const LatestForumPostsBlock = asFetchableBlock(LatestForumPosts, BlockType.latestforumposts);
export type LatestForumPostsBlock = ComponentProps<typeof LatestForumPostsBlock>;
